import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconEdit = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.5 10C17.5 13.5358 17.5 15.3033 16.4017 16.4017C15.3033 17.5 13.535 17.5 10 17.5C6.46417 17.5 4.69667 17.5 3.59833 16.4017C2.5 15.3033 2.5 13.535 2.5 10C2.5 6.46418 2.5 4.69667 3.59833 3.59834C4.69667 2.50001 6.465 2.50001 10 2.50001M7.94417 9.29168C7.65977 9.57649 7.50002 9.96252 7.5 10.365V12.5H9.64833C10.0508 12.5 10.4375 12.34 10.7225 12.055L17.0558 5.71834C17.1969 5.57735 17.3087 5.40995 17.3851 5.22572C17.4614 5.04148 17.5007 4.84401 17.5007 4.64459C17.5007 4.44517 17.4614 4.2477 17.3851 4.06347C17.3087 3.87923 17.1969 3.71184 17.0558 3.57084L16.43 2.94501C16.289 2.80386 16.1215 2.69188 15.9372 2.61548C15.7529 2.53908 15.5554 2.49976 15.3558 2.49976C15.1563 2.49976 14.9587 2.53908 14.7744 2.61548C14.5901 2.69188 14.4227 2.80386 14.2817 2.94501L7.94417 9.29168Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconEdit.displayName = "IconEdit";

export { IconEdit };
